import request from 'api/requestUtils'
import type { paths } from '@luxuryescapes/contract-cart'
import { mapRevokeMultiCartMemberResponse } from './multiCartMappers'

type RevokeUserAccessResponse = paths['/api/carts/multi-carts/{multiCartId}/users/revoke']['patch']['responses']['200']['content']['application/json']
type RevokeUserAccessRequest = paths['/api/carts/multi-carts/{multiCartId}/users/revoke']['patch']['requestBody']['content']['application/json']

export type RevokeUserAccessParams =
  | { cartId: string, userId: string }
  | { cartId: string, email: string }

export function revokeUserAccessMultiCart(params: RevokeUserAccessParams): Promise<{ cartId: string, user: App.MultiCartMember }> {
  const { cartId } = params
  const requestBody: RevokeUserAccessRequest = 'userId' in params ? { userId: params.userId } : { email: params.email }

  return request.patch<RevokeUserAccessResponse, RevokeUserAccessRequest>(`/api/carts/multi-carts/${cartId}/users/revoke`, requestBody, { credentials: 'include' }).then(mapRevokeMultiCartMemberResponse)
}
